import React from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { Link } from 'react-router-dom'

import { makeLink } from '../../../../common/utils/urlHelper'

class RelatedSearchesItem extends React.Component {
  static propTypes = {
    term: PropTypes.string,
    type: PropTypes.string,
    amGridCol: PropTypes.string,
    amGridRow: PropTypes.string
  }

  static customAttributes = [
    'am-grid-col',
    'am-grid-row'
  ]

  componentDidMount () {
    const dom = findDOMNode(this)
    /*
     This procedure is unfortunately necessary. React removes custom attributes from DOM and
     current design depend on am-grid-col and amd-grid-row attributes. The only way to add those is to
     do it directly on DOM after component mounted.
     */
    RelatedSearchesItem.customAttributes.forEach((attributeName) => {
      dom.setAttribute(attributeName, this.props[attributeName])
    })
  }

  render () {
    const { term, type } = this.props
    let nextQuery = {}
    nextQuery[type] = term

    return (
      <li className='fds-c-text-body -size-s fds-u-m0'>
        <Link className='fds-c-text-link -color-default -decoration-reversed'
          to={makeLink(nextQuery)}>{term}</Link>
      </li>
    )
  }
}

class RelatedSearches extends React.Component {
  static propTypes = {
    recommendations: PropTypes.array,
    type: PropTypes.string,
    hint: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.setListRef = this.setListRef.bind(this)
  }

  componentDidMount () {
    /*
      Needed to add a custom attribute for design purpose.
     */
    if (this.listElement) {
      const listDOM = findDOMNode(this.listElement)
      listDOM.setAttribute('am-grid', 'abc')
    }
  }

  setListRef (listElement) {
    this.listElement = listElement
  }

  render () {
    const { recommendations, type, hint } = this.props
    return (
      <div className='fds-u-clearfix fds-u-mb2'>
        <p className='fds-c-text-body -size-l fds-u-mb1'>
          Searches related to
          <span className='fds-c-text-body -size-l -weight-bold'> {hint}</span>
        </p>
        <ul ref={this.setListRef}>
          {recommendations.map((term, index) => {
            return (
              <RelatedSearchesItem key={index} term={term} type={type}
                am-grid-col='s:4 m:8 l:6' am-grid-row={index % 2 ? 'l:end' : 'l:start'} />
            )
          })}
        </ul>
      </div>
    )
  }
}

export default RelatedSearches



// WEBPACK FOOTER //
// ./client/pages/search/result/relatedSearches.js